var React = require('react');

function InstagramSecondary (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 8 3 C 5.239 3 3 5.239 3 8 L 3 16 C 3 18.761 5.239 21 8 21 L 16 21 C 18.761 21 21 18.761 21 16 L 21 8 C 21 5.239 18.761 3 16 3 L 8 3 z M 18 5 C 18.552 5 19 5.448 19 6 C 19 6.552 18.552 7 18 7 C 17.448 7 17 6.552 17 6 C 17 5.448 17.448 5 18 5 z M 12 7 C 14.761 7 17 9.239 17 12 C 17 14.761 14.761 17 12 17 C 9.239 17 7 14.761 7 12 C 7 9.239 9.239 7 12 7 z M 12 9 A 3 3 0 0 0 9 12 A 3 3 0 0 0 12 15 A 3 3 0 0 0 15 12 A 3 3 0 0 0 12 9 z"}));
}

InstagramSecondary.defaultProps = {"viewBox":"2 2 20 20","width":"24px","height":"24px","fill":"#1B4521"};

module.exports = InstagramSecondary;

InstagramSecondary.default = InstagramSecondary;
